
<template>
<div>
  <div class="top-bar">
    <div>
      <a class="logo-image" href="#">
        <img src="../assets/images/branding/ArcaneFullWhite.png">
      </a>
    </div>
    <div class="slogan">
      <span>Delivering magic to adventurers' tables</span><span class="tm">™</span>
    </div>
  </div>
  <div class="home" :class="activeClass">
      <div class="shop half" @mouseover="setActiveClass('shop-active')" @mouseout="setActiveClass('')">
        <div class="wrapper">
          <div class="color-overlay">
            <div class="summary-section">
                <h3>Looking for our Spectacles?</h3>
                <router-link to="/shop">
                    <div class="button white"> BROWSE OUR SHOP</div>
                </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="website half" @mouseover="setActiveClass('site-active')" @mouseout="setActiveClass('')">
        <div class="wrapper">
            <div class="color-overlay">
              <div class="summary-section">
                  <h3>Partners, Community Spotlights, Charities and About Us</h3>
                  <router-link to="">
                    <div class="button white" style="border:none;">
                      <span class="badge badge-light" style="font-size: 1em;;">COMING SOON</span>
                    </div>
                  </router-link>
              </div>
            </div>
        </div>
      </div>
      <div class="splitter elevation-1">
          <div class="icon elevation-1"></div>
      </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'HomePage',
    data () {
        return {
            activeClass: ''
        }
    },
    mounted () {
    },
    methods: {
        setActiveClass (activeClass) {
            this.activeClass = activeClass
        }
    },
    components: {
    }
}
</script>

<style>
.top-bar {
  height: 110px;
  margin: 0px;
  padding: 5px 0;
  width: 100%;
  background-color: #493761;
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.top-bar .logo-image img {
  height: 60px;
  padding-right: 0.25em;
}

.slogan {
  margin: 0px;
  padding: 0px;
  letter-spacing: 1px;
}

.slogan span {
  text-transform: uppercase;
  font-size: 14px;
}

.slogan span.tm {
  font-size: 20px;
}


.home {
  width: 100%;
  height: calc(100vh - 110px);
  display: flex;
}

.home .half {
  width: 50%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  transition: all 0.5s ease;
}

.home .half.shop {
  background-image: url('../assets/images/branding/ArcaneBanner.jpg')
}

.home .half.website {
  background-image: url('../assets/images/branding/WoodPlain.jpg')
}

.home .wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.home .wrapper .color-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.home .half.website .color-overlay {
  background: rgba(0, 188, 250, 0.5);
}

.home .half.shop .color-overlay {
  background: rgba(68, 0, 99, 0.5);
}

.home .wrapper .summary-section {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.home .wrapper .summary-section h3 {
  width: 400px;
}

.home .wrapper .summary-section a:hover {
  text-decoration: none !important;
}

.home .wrapper .summary-section h3, .home .wrapper .summary-section h1 {
  color: white;
}

.home .button.white {
  margin-top: 10px;
  color: #fff;
  border: 2px solid #fff;
  background-color: transparent;
  padding: 14px 16px 12px;
  border-radius: 4px;
}

.home .button.white:hover {
  text-decoration: underline;
}

.home .splitter {
  width: 1px;
  height: 100%;
  /* background: #000000; */

  position: absolute;
  top: 0;
  left: calc(100vw / 2);

  transition: all 0.5s ease;
}

.elevation-1 {
  box-shadow: 0 4px 8px rgba(0 17, 53,0.4), 0 0 2px rgba(0,17,53,0.6), 0 0 1px rgba(0,17,53,0.4) !important;
}

.home .splitter .icon {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-image: url('../assets/images/branding/ArcaneMascotLogo.png');
  /* background-color: #493761; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 150px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.home.shop-active .shop {
  width: 60%;
}

.home.shop-active .website {
  width: 40%;
}

.home.shop-active .splitter {
  left: calc((100vw / 2) + 10%);
}

.home.site-active .splitter {
  left: calc((100vw / 2) - 10%);
}

.home.site-active .website {
  width: 60%;
}

.home.site-active .shop {
  width: 40%;
}

@media (max-width: 1200px) {
  .home .wrapper .summary-section h3 {
    width: 300px;
  }

  .home .splitter .icon {
    width: 120px;
    height: 120px;
    background-size: 120px;
  }
}

@media (max-width: 900px) {
  .home {
    display: block;
    height: calc(100vh - 110px);
  }
  .home .half {
    width: 100%;
    height: calc((100vh - 110px) / 2);
  }
  .home .splitter .icon {
    width: 100px;
    height: 100px;
    background-size: 100px;
  }

  .home .splitter {
    width: 100%;
    height: 1px;

    position: absolute;
    left: 0;
    top: calc((100vh + 110px) / 2 - 1px);

    transition: all 0.5s ease;
  }

  .home.shop-active .shop {
    height: 60%;
    width: 100%;
  }

  .home.shop-active .website {
    height: 40%;
    width: 100%;
  }

  .home.shop-active .splitter {
    top: calc(((100vh + 110px) / 2) + 10% - 8px);
    left: 0;
  }

  .home.site-active .splitter {
    top: calc(((100vh + 110px) / 2) - 10% + 8px);
    left: 0;
  }

  .home.site-active .website {
    height: 60%;
    width: 100%;
  }

  .home.site-active .shop {
    height: 40%;
    width: 100%;
  }

  .home .wrapper .summary-section h3 {
    width: 400px;
  }
}

@media (max-width: 500px) {
  .home .wrapper .summary-section h3 {
    font-size: 1.25em;
    width: 250px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/HomePage.vue